<template>
    <div  class="alert alert-warning col-12 text-center py-4">Aucun résultat trouvé</div>
</template>